export default "__VITE_ASSET__$ry3wzRG__"